import React from 'react'
import upperFirst from 'lodash/upperFirst'
import { compose, withState } from 'recompose'
import { clone } from 'lodash'
import CmsApis from 'apis/cmsApis'
import Modal from 'components/modals/Modal'
import FormInput from 'components/forms/bases/FormInput'
import Container from 'components/Container'
import Paper from 'material-ui/Paper'
import withSnackBar from 'store/snackbar/withSnackBar'

const withDuplicateResource = ({
  resourceName = {
    singular: '',
    plural: '',
  },
}) => {
  const singularName = resourceName.singular
  const pluralName = resourceName.plural
  const ResourceName = upperFirst(singularName)
  return (WrappedComponent) => compose(
    withSnackBar,
    withState('openModal', 'setOpenModal', false),
    withState('newResourceName', 'setNewResourceName', ''),
    withState('originalResourceInfo', 'setOriginalResourceInfo', ''),
    withState('duplicateStatus', 'setDuplicateStatus', { duplicateStatus: { isRequest: false, isSuccess: false } }),
  )(({
    openModal,
    setResources,
    setOpenModal,
    setDuplicateStatus,
    setNewResourceName,
    setOriginalResourceInfo,
    newResourceName,
    originalResourceInfo,
    duplicateStatus,
    showMessage,
    ...props
  }) => {
    const onSubmitFormModal = () => {
      const newResourceInfo = clone(originalResourceInfo)
      const apiAction = CmsApis[`duplicate${ResourceName}`]
      const resources = props[pluralName]
      const isDuplicateNameResource = resources.find(
        (resource) => (resource.name === newResourceName)) !== undefined
      if (!isDuplicateNameResource) {
        newResourceInfo.requestId = originalResourceInfo.id
        newResourceInfo.name = newResourceName
        setDuplicateStatus({ isRequest: true, isSuccess: false })
        showMessage({ message: null })
        apiAction(newResourceInfo)
          .then(({ data }) => {
            setDuplicateStatus({ isRequest: false, isSuccess: false })
            showMessage({ message: `${newResourceInfo.name} has created.` })
            const index = resources.findIndex(((obj) =>
              (obj.name === originalResourceInfo.name)))
            const newResources = [
              ...resources.slice(0, index + 1),
              data,
              ...resources.slice(index + 1),
            ]
            setResources(newResources)
          })
          .catch(() => {
            setDuplicateStatus({ isRequest: false, isSuccess: false })
            showMessage({ message: `Duplicate ${singularName} error, This ${singularName} name is already exist.` })
          })
        setOpenModal(false)
      } else {
        showMessage({ message: null })
        showMessage({ message: `Duplicate ${singularName} error, This ${singularName} name is already exist.` })
      }
    }
    return (
      <Container>
        <Paper>
          <WrappedComponent
            setOpenModal={setOpenModal}
            setOriginalResourceInfo={setOriginalResourceInfo}
            setNewResourceName={setNewResourceName}
            duplicateStatus={duplicateStatus}
            {...props}
          />
          <Modal
            title={`Input your ${ResourceName} name`}
            open={openModal}
            onClose={() => setOpenModal(!openModal)}
            onSubmit={onSubmitFormModal}
          >
            <FormInput
              onChange={(newValue) => setNewResourceName(newValue)}
              value={newResourceName}
            />
          </Modal>
        </Paper>
      </Container>
    )
  })
}

export default withDuplicateResource




// WEBPACK FOOTER //
// ./src/hocs/extends/withDuplicateResource.js